(function () {
  function initOoMainMenuPin() {
    const nav = document.querySelector('.oo-header-row-2');
    if (!nav) return;

    const mainItems = Array.from(nav.querySelectorAll('.oo-main-menu-item--has-children'));
    if (!mainItems.length) return;

    const getPinnedItem = () => nav.querySelector('.oo-main-menu-item--has-children.is-open-pinned');

    const clearPinned = () => {
      const wasPinned = getPinnedItem();
      mainItems.forEach((item) => item.classList.remove('is-open-pinned'));
      // Voorkom dat :focus-within het oude megamenu open houdt na “unpin”.
      if (
        wasPinned &&
        wasPinned.contains(document.activeElement) &&
        document.activeElement?.matches?.('a.oo-main-menu-link')
      ) {
        document.activeElement.blur();
      }
    };

    const pinItem = (item) => {
      if (!item) return;
      clearPinned();
      item.classList.add('is-open-pinned');
    };

    const allTopItems = Array.from(nav.querySelectorAll('.oo-main-menu-item'));

    mainItems.forEach((item) => {
      const link = item.querySelector('.oo-main-menu-link--has-children');
      if (!link) return;

      link.addEventListener('click', (event) => {
        // Keep native browser behavior for modified clicks.
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        pinItem(item);
      });
    });

    // Pin alleen via klik; hover op een ander hoofditem heft de pin op (normaal hover-gedrag).
    allTopItems.forEach((item) => {
      item.addEventListener('mouseenter', () => {
        const pinnedItem = getPinnedItem();
        if (pinnedItem && pinnedItem !== item) {
          clearPinned();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!event.target.closest('.oo-header-row-2')) {
        clearPinned();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        clearPinned();
      }
    });
  }

  function initOoMenuTree() {
    const dropdowns = document.querySelectorAll('.oo-main-menu-dropdown-inner');
    if (!dropdowns.length) return;

    dropdowns.forEach((dropdown) => {
      const treeLinks = dropdown.querySelectorAll('[data-oo-tree-link]');
      const panels = dropdown.querySelectorAll('[data-oo-tree-panel]');
      if (!treeLinks.length) return;

      const treeWithPanels = dropdown.querySelectorAll('.oo-main-menu-tree-item--has-panel');

      const clearPanelOpenOnTree = () => {
        treeWithPanels.forEach((el) => el.classList.remove('is-panel-open'));
      };

      const setActivePanel = (index) => {
        panels.forEach((panel) => panel.classList.remove('is-active'));
        clearPanelOpenOnTree();
        if (index === 'view-all') {
          return;
        }
        const activePanel = dropdown.querySelector(`[data-oo-tree-panel="${index}"]`);
        if (activePanel) {
          activePanel.classList.add('is-active');
          const treeRow = dropdown.querySelector(
            `[data-oo-tree-item="${index}"].oo-main-menu-tree-item--has-panel`
          );
          if (treeRow) treeRow.classList.add('is-panel-open');
        }
      };

      const clearPanels = () => {
        panels.forEach((panel) => panel.classList.remove('is-active'));
        clearPanelOpenOnTree();
      };

      treeLinks.forEach((link) => {
        const index = link.getAttribute('data-oo-tree-link');
        link.addEventListener('mouseenter', () => setActivePanel(index));
        link.addEventListener('focus', () => setActivePanel(index));
      });

      const menuItem = dropdown.closest('.oo-main-menu-item--has-children');
      if (menuItem) {
        menuItem.addEventListener('mouseleave', clearPanels);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initOoMainMenuPin();
      initOoMenuTree();
    });
  } else {
    initOoMainMenuPin();
    initOoMenuTree();
  }
})();
